module.exports = __webpack_public_path__ + "static/media/user-dashboard-client-profile-with-no-photo@2x.529e0a7d.png";